import { connect } from 'react-redux';
import { requestToggleFullscreenView } from '../../../DeviationPage/redux/actions';
import { getIsFullscreenAllowed } from '../../../DeviationPage/redux/selectors';
var mapStateToProps = function (state, _a) {
    var deviation = _a.deviation;
    return ({
        canFullscreen: getIsFullscreenAllowed(state),
    });
};
var mapDispatchToProps = {
    onClick: requestToggleFullscreenView,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=ExpandButton.container.js.map